<div class="sticky-top mat-elevation-z6">
    <mat-toolbar class="trip-header-bar bds-toolbar-blue">
        <mat-toolbar-row>
            <span>
                <!-- <fa-icon [icon]="iconFlag" [fixedWidth]="true" size="lg"></fa-icon> -->
                Mismatched Status
            </span>
            <span class="fill-remaining-space"></span>
        </mat-toolbar-row>
    </mat-toolbar>
</div>
<rt-jeopardized-shipment-reason-common
    [trip]="trip$ | async"
    [showOriginCriteria]="true"
    [showDestinationCriteria]="true"
    [useExpansionPanel]="false"
    (saveClick)="onTripSaveClicked($event)"
    (popoutTrip)="onPopoutTripclicked($event)"
></rt-jeopardized-shipment-reason-common>
<ng-template #loading> Loading... </ng-template>
